<template>
  <!--额度不足 开始-->
  <div class="dia-info">
    <el-dialog :visible.sync="frameNoLimitDialog" top="35vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" center class="textcenter">
      <div style="width:100%;text-align: center;">
        <div><img src="/static/img/frame/nolimit.png" class="frame-big-img" @click="refresh"></div>
        <div class="frame-text-hotel-sold wordBreak">
          Sorry, your authorization limit is no longer enough. Please contact the docking operation to recharge.
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button class="booknow_button" style="float: none; width: auto;" @click="closeFrame">OK</el-button>
      </span>
    </el-dialog>
  </div>
  <!--额度不足 结束-->
  <!--引入方式-->
</template>

<script>
export default {
  name: 'frameNoLimit',
  props: ['frameNoLimitDialog'],
  data () {
    return {
      frameWidth: '450px',
      showClo: false
    }
  },
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }
  },
  methods: {
    refresh () {
      location.reload()
      this.frameNetworkDialog = false
    },
    closeFrame () {
      this.$emit('SetFrameNoLimit', false)
    }
  }
}
</script>

<style scoped>
.textcenter{text-align: center;}
.frame-big-img{width:100px; height:100px;cursor: pointer;}
.frame-text-hotel-sold{height:20px; font-size: 16px;color: #4F4C4C;text-align: center; margin-top: 10px;}
.dia-info /deep/ .el-dialog__header{padding: 0;}
</style>



// WEBPACK FOOTER //
// src/components/public/frameNoLimit.vue